<template>
  <div class="flex flex-col items-center">
    <img :src="require('./../assets/awaiting.jpg')" alt="En attente de validation" class="mb-6 w-72" />
    <span class="">Vous avez déjà un projet en attente de validation.</span>
    <p>
      <fa-icon type="far" icon="info-circle" />
      Veuillez réessayer après validation de votre projet précédent
    </p>
    <button class="btn btn-primary btn-lg mt-6 px-10" @click="$root.close">Fermer</button>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      confirmationState: null
    }
  },
  computed: {
    ...mapStores(useMainStore)
  }
}
</script>
